//封装操作localstorage本地存储的方法
export var storage = {
    //存储
    set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    //取出数据
    get(key) {
        return JSON.parse(localStorage.getItem(key));
    },
    // 删除数据
     remove(key) {
        localStorage.removeItem(key);
    }
};

export var sessionstorage = {
    //存储
    set(key, value) {
        sessionStorage.setItem(key,value);
    },
    //取出数据
    get(key) {
        return sessionStorage.getItem(key);
    },
    // 删除数据
     remove(key) {
        sessionStorage.removeItem(key);
    }
};

export var storageKey = {
    CITY:'city',
    STORE:'store',
    SIGN:'sign',
    PHONE:'phone',
	paycard:'paycard',
	

}
